import { useUser } from "MVVM/Hooks/useUser";

export const useProEditAccess = () => {
  const { allstarUser } = useUser();

  const userGroupType = allstarUser?.user?.userGroup?.type;
  const hasValidUserGroup =
    userGroupType === "INTERNAL" ||
    userGroupType === "CREATOR_PLAT" ||
    userGroupType === "PRO" ||
    userGroupType === "ESSENTIALS";

  return {
    hasProEditAccess: hasValidUserGroup,
    hasValidUserGroup,
  };
};
